import { YANDEX_METRIKA_SCRIPT } from '../../constants/analytics';

export const ScriptYM = () => (
  <script
    dangerouslySetInnerHTML={{ __html: YANDEX_METRIKA_SCRIPT }}
  />
);